export const MED_CHANGES_OPTIONS = [
  { label: "Increase", value: "INCREASE" },
  { label: "Decrease", value: "DECREASE" },
  { label: "Maintain", value: "MAINTAIN" },
  { label: "Discontinue", value: "DISCONTINUE" },
];
